import React, { lazy, Suspense } from "react"
import * as styles from "./LandingHeader.module.scss"
import LandingMobileMenu from "./LandingNavigation/LandingMobileMenu"
import { Link } from "gatsby"
import { useSiteQuery } from "../../../hooks/layout/useSiteQuery"
import {
  HeaderProvider,
  useHeaderContext,
} from "../../../hooks/layout/HeaderContext"

const LandingDesktopMenu = lazy(
  () => import("./LandingNavigation/LandingDesktopMenu")
)
import { useIsDesktop } from "../../../hooks/function/useIsDesktop"
import WhatsAppLink from "../../WhatsApp/WhatsAppLink"

const HeaderContent = () => {
  const { headerLogo, headerItems } = useSiteQuery()
  const { isOpen, setIsOpen, handleLinkClick } = useHeaderContext()
  const isDesktop = useIsDesktop()

  const transformHeaderItems = items => {
    return items.map(item => ({
      type: item.type || "default",
      title: item.title,
      subTitle: item.subTitle,
      slug: item.slug || "#",
      svgIcon: item.svgIcon || undefined,
      children: item.headerSections
        ? transformHeaderItems(item.headerSections)
        : [],
    }))
  }

  const menuItems = headerItems ? transformHeaderItems(headerItems) : []

  return (
    <header className={`bg-white ${styles.stickyHeader}`}>
      <div className={`${styles.containerWithoutPadding}`}>
        <div className={styles.logo}>
          <img
            src={headerLogo?.file.url}
            height={headerLogo?.height}
            width={headerLogo?.width}
            alt={headerLogo?.title}
            className={styles.headerLogo}
            onClick={handleLinkClick}
          />
          <div className={styles.whatsappWraper}>
            {" "}
            <WhatsAppLink
              phoneNumber="919205987106"
              message="Hi, I'm interested in your services."
              loading="eager"
            />{" "}
            <p>+91-9205987106</p>
          </div>
        </div>

        {isDesktop ? (
          <Suspense fallback={null}>
            <LandingDesktopMenu menuItems={menuItems} />
          </Suspense>
        ) : (
          <div className="mobile">
            <div className={styles.toggleWrapper}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.toggleBtn} ${isOpen ? styles.open : ""}`}
                aria-label={isOpen ? "Close menu" : "Open menu"}
              >
                <svg
                  className={styles.toggle}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>

            {isOpen && (
              <LandingMobileMenu menuItems={menuItems} setIsOpen={setIsOpen} />
            )}
          </div>
        )}
      </div>
    </header>
  )
}

const Header = () => (
  <HeaderProvider>
    <HeaderContent />
  </HeaderProvider>
)

export default Header
